<div class="google-news-container p-4">
  <div class="header flex justify-between items-center mb-4">
    <h2 class="text-xl font-bold flex items-center gap-2">
      <mat-icon class="text-red-600">newspaper</mat-icon>
      今日谷歌新聞
    </h2>
    <button mat-icon-button (click)="refresh()" matTooltip="重新整理">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <mat-tab-group animationDuration="0ms" class="bg-white rounded-lg shadow-sm">
    @for (category of categories(); track category) {
      <mat-tab [label]="category.name">
        <div class="news-content p-4 min-h-75">
          <!-- Loading State -->
          @if (category.loading) {
            <div class="flex justify-center items-center h-48">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          }
          <!-- Error State -->
          @if (category.error) {
            <div class="flex flex-col justify-center items-center h-48 text-red-500">
              <mat-icon class="text-4xl mb-2">error_outline</mat-icon>
              <p>{{ category.error }}</p>
            </div>
          }
          <!-- News List -->
          @if (!category.loading && !category.error && category.items.length > 0) {
            <mat-list>
              @for (item of category.items; track item; let i = $index) {
                <div class="mb-3 hover:bg-gray-50 rounded-lg transition-colors p-2 border-b border-gray-100 last:border-0">
                  <a [href]="item.link" target="_blank" class="flex flex-col gap-1 no-underline text-inherit group">
                    <div class="flex justify-between items-start">
                      <h3 class="font-medium text-base text-gray-800 group-hover:text-blue-600 transition-colors line-clamp-2">
                        <span class="text-gray-400 font-normal mr-2">#{{i+1}}</span>
                        {{ item.title }}
                      </h3>
                    </div>
                    <div class="flex justify-between items-center text-sm text-gray-500 mt-1">
                      <div class="flex items-center gap-2">
                        <span class="px-2 py-0.5 bg-gray-100 rounded text-xs font-medium text-gray-600">
                          {{ item.source || 'Unknown' }}
                        </span>
                        <span class="text-xs">{{ item.pubDate }}</span>
                      </div>
                      <!-- <mat-icon class="text-gray-300 transform group-hover:translate-x-1 transition-transform text-sm h-4 w-4">open_in_new</mat-icon> -->
                    </div>
                  </a>
                </div>
              }
            </mat-list>
          }
          @if (!category.loading && !category.error && category.items.length === 0) {
            <div class="flex justify-center items-center h-48 text-gray-400">
              尚無新聞
            </div>
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
